import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";

import OktaAuth from "@okta/okta-auth-js";

const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + "/implicit/callback"
});

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_GRAPHQL_URI}/graphql`
});

const authLink = setContext(async (_, { headers }) => {
  /**
   * The tokenManager takes care of refreshing the token.
   * If its not expired it will get the token from localStorage.
   * Otherwise it will get a new one from okta.
   */
  try {
    let tokenManagerResponse = await oktaAuth.tokenManager.get("accessToken");
    if (tokenManagerResponse) {
      // return the headers to the context so httpLink can read them
      const { accessToken } = tokenManagerResponse;
      return {
        headers: {
          ...headers,
          authorization: `Bearer ${accessToken}`
        }
      };
    } else {
      window.localStorage.clear();
      return headers;
    }
  } catch (err) {
    //If there's an error, the Okta auto renewal might have failed so have the user log in again.
    window.localStorage.clear();
  }
});

const graphqlClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    addTypename: false
  })
});

export default graphqlClient;



// WEBPACK FOOTER //
// ./src/httpClients/graphqlClient.js